/**
 * Generate the HTML ID for a footnote ID.
 */
export function footnoteIdToHtmlId(id: string) {
    return `user-content-fn-${id}`;
}
